/**
 * Operator nav for the pipeline product: Workflow / Ingest / Tools / Raise package.
 */
import { escapeHtml } from "./dashboard-html.js";

export type PipelineOperatorView = "workflow" | "ingest" | "tools" | "raise";

export function ingestRequested(): boolean {
  if (typeof window === "undefined") return false;
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  return path === "/ingest";
}

export function toolsRequested(): boolean {
  if (typeof window === "undefined") return false;
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  return path === "/tools";
}

export function pipelineWorkflowRequested(): boolean {
  if (typeof window === "undefined") return true;
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  return path === "/" || path === "/workflow";
}

export function readPipelineOperatorView(): PipelineOperatorView {
  if (typeof window === "undefined") return "workflow";
  if (ingestRequested()) return "ingest";
  if (toolsRequested()) return "tools";
  const raise = new URLSearchParams(window.location.search).get("raise_package")?.trim().toLowerCase() ?? "";
  if (raise === "1" || raise === "true") return "raise";
  return "workflow";
}

export function pipelineOperatorNavHtml(view: PipelineOperatorView = readPipelineOperatorView()): string {
  const active = (name: PipelineOperatorView): string => (view === name ? ' class="is-active" aria-current="page"' : "");
  return `
      <nav class="lead-generation-nav" aria-label="pipeline views" data-pipeline-operator-nav>
        <a href="/workflow"${active("workflow")}>Workflow</a>
        <a href="/ingest"${active("ingest")}>Ingest</a>
        <a href="/tools"${active("tools")}>Tools</a>
        <a href="/?raise_package=1"${active("raise")}>Raise package</a>
      </nav>
  `;
}

export function renderRetiredGoRules(mount: HTMLElement): void {
  mount.innerHTML = `
    <main class="error-state" data-gorules-retired>
      ${pipelineOperatorNavHtml("workflow")}
      <p class="eyebrow">Decision layer</p>
      <h1>GoRules editor retired</h1>
      <p>The JDM editor is not an operator workflow. Pipeline steps live on the Workflow board.</p>
    </main>
  `;
}

export function retiredSurfaceHtml(title: string, message: string): string {
  return `
    <main class="error-state">
      ${pipelineOperatorNavHtml()}
      <h1>${escapeHtml(title)}</h1>
      <p>${escapeHtml(message)}</p>
    </main>
  `;
}
